import { AmazonConnectCcpLauncher } from '@montugroup/clinic-telecom';

export type AmazonConnectProps = {
  isEnabled: boolean;
};

export const AmazonConnect = ({ isEnabled }: AmazonConnectProps) => {
  if (!isEnabled) {
    return null;
  }

  return <AmazonConnectCcpLauncher />;
};
